
export default function initTabs(): void {
    const $tabsContainer = document.querySelectorAll<HTMLElement>('.js-tabs');

    $tabsContainer.forEach($container => {
        new Tabs($container);
    });
}

class Tabs {
    $el: HTMLElement | null | undefined;


    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.init();
    }

    init(): void {
        if (this.$el) {
            const $tabButtons = this.$el.querySelectorAll('.tab-button');
            const $tabContents = this.$el.querySelectorAll('.tab-content');

            $tabButtons[0].classList.add('tab-button--active');
            $tabContents[0].classList.add('tab-content--active');

            let index;

            $tabButtons.forEach(button => {
                button.addEventListener('click', () => {
                    $tabButtons.forEach(button => button.classList.remove('tab-button--active'));
                    button.classList.add('tab-button--active');
                    index = button.getAttribute('data-tab');

                    $tabContents.forEach(content => {
                        content.classList.remove('tab-content--active');
                        if (index === content.getAttribute('data-tab')) {
                            content.classList.add('tab-content--active');
                        }
                    })
                })
            })
        }
    }
}